<span class="clipboard-output">{{ clipboardValue }}</span>
@if (icon) {
  <rt-icon [name]="icon" [size]="'small-x'"></rt-icon>
}
<span class="content-wrapper">
  <span class="prevent-copy" [attr.data-text]="displayValue"></span>
  <ng-content></ng-content>
</span>
@if (dropdownOpen !== undefined) {
  <span class="dropdown-icon"></span>
}
